import { createSlice, createSelector } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";
import { PageContext } from "admin/types/pageContext";
import { RootState } from "admin/store";

const key = "pageContext";

const initialState: PageContext.PageContextState = {
  pageContext: null,
};

/** slice * */
export const pageContextSlice = createSlice({
  name: key,
  initialState,
  reducers: {
    setPageContext: (state, action) => {
      state.pageContext = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return { ...state, ...action.payload.pageContext };
    });
  },
});

/** selector * */
const stateSelector = (state: RootState) => state[key];

export const pageContextSelector = createSelector(
  stateSelector,
  (state) => state.pageContext,
);

// action export
export const { setPageContext } = pageContextSlice.actions;
